import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Sharp, block-style button. Square corners, bold uppercase text, 2px border.
 * Variants: orange, leaf, teal, red, yellow, ink, cream, ghost
 */
export default function SquareButton({
  to,
  href,
  onClick,
  type = 'button',
  variant = 'orange',
  size = 'md',
  className = '',
  children,
  disabled = false,
  testId,
  fullWidth = false,
  ...rest
}) {
  const variantClass = {
    orange: 'bg-grad-mango hover:saturate-110 text-white border-[hsl(var(--c-ink))]',
    leaf: 'bg-grad-forest-soft hover:saturate-125 text-white border-[hsl(var(--c-ink))]',
    teal: 'bg-grad-emerald hover:saturate-125 text-white border-[hsl(var(--c-ink))]',
    red: 'bg-grad-sunset hover:saturate-125 text-white border-[hsl(var(--c-ink))]',
    yellow: 'bg-[hsl(var(--c-mango-yellow))] hover:bg-[hsl(41_100%_55%)] text-[hsl(var(--c-ink))] border-[hsl(var(--c-ink))]',
    ink: 'bg-grad-forest hover:saturate-125 text-white border-[hsl(var(--c-ink))]',
    cream: 'bg-white hover:bg-[hsl(var(--c-cream))] text-[hsl(var(--c-ink))] border-[hsl(var(--c-ink))]',
    ghost: 'bg-transparent hover:bg-[hsl(var(--c-cream-deep))] text-[hsl(var(--c-ink))] border-[hsl(var(--c-ink))]',
    emerald: 'bg-grad-emerald hover:saturate-125 text-white border-[hsl(var(--c-ink))]',
    forest: 'bg-grad-forest hover:saturate-125 text-white border-[hsl(var(--c-ink))]',
  }[variant] || '';

  const sizeClass = {
    sm: 'h-10 px-4 text-xs',
    md: 'h-12 px-6 text-sm',
    lg: 'h-14 px-8 text-sm',
  }[size] || 'h-12 px-6 text-sm';

  const cls = `btn-square btn-transition inline-flex items-center justify-center border-2 font-bold uppercase tracking-wider ${variantClass} ${sizeClass} ${fullWidth ? 'w-full' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`;

  if (to) {
    return (
      <Link to={to} data-testid={testId} className={cls} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} data-testid={testId} className={cls} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} disabled={disabled} data-testid={testId} className={cls} {...rest}>
      {children}
    </button>
  );
}
